import React from 'react';
import { Wordmark } from './BrandArtwork';
import { FooterCatVignette } from './FooterCatVignette';
import { navLinks } from '../data/site';
export function SiteFooter() {
  return <footer className="relative min-h-[620px] overflow-hidden border-t border-ink/10 bg-cream md:min-h-[640px] lg:min-h-[660px]" data-id="element-121" data-mp="3mh9i07pj8jg1">
      <FooterCatVignette data-id="element-122" data-mp="3hherw6dkzxw1" />

      <div className="relative z-10 mx-auto flex min-h-[620px] max-w-content flex-col px-5 pb-8 pt-16 md:min-h-[640px] md:px-8 lg:min-h-[660px] lg:px-10" data-id="element-123" data-mp="3hi6bsjxtg76h">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12" data-id="element-124" data-mp="38h8eekhvuxwv">
          <div className="md:col-span-6" data-id="element-125" data-mp="38k4eaedajwny">
            <Wordmark className="h-8 w-auto md:h-10" data-id="element-126" data-mp="33jq52szyegoc" />
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ink/75" data-id="element-127" data-mp="33ki0a2pn2ce3">
              A boutique app studio building original apps for learning, life and play.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-6 md:grid-cols-2" data-id="element-128" data-mp="ws7i9fhiq0ne">
            <nav aria-label="Footer" data-id="element-129" data-mp="wq4hc0etun3w">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-130" data-mp="15qc2qiov5ni2">
                Sections
              </h2>
              <ul className="mt-4 space-y-1" data-id="element-131" data-mp="1arj9qfj6mino">
                {navLinks.map(link => <li key={link.href} data-id="element-132" data-mp="vtz8njpep7ms">
                    <a href={link.href} className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-133" data-mp="vv213w2dni4t">
                      {link.label}
                    </a>
                  </li>)}
                <li data-id="element-134" data-mp="1es33ra8gl65l">
                  <a href="#top" className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-135" data-mp="1eqs2bh2hkahn">
                    Back to top
                  </a>
                </li>
              </ul>
            </nav>

            <div data-id="element-136" data-mp="2c90k1096jlsa">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-137" data-mp="2m2xnlxpur6ba">
                Studio
              </h2>
              <ul className="mt-4 space-y-3 text-[15px] text-ink/80" data-id="element-138" data-mp="2h4w6hibzlh2g">
                <li data-id="element-139" data-mp="2d1zkrir5h4ua">blackcometlabs.io</li>
                <li data-id="element-140" data-mp="2d0wrj46cuqb7">Learning · Lifestyle · Gaming</li>
                <li data-id="element-141" data-mp="283eti8tvlvhz">Built for U.S. users</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-20" data-id="element-142" data-mp="234lg0gela4ht">
          <div className="h-px w-full bg-ink/15" aria-hidden="true" data-id="element-143" data-mp="235mpigfyiixf" />
          <p className="pr-16 pt-5 text-xs font-medium text-ink/65" data-id="element-144" data-mp="1yd3bxjh9rnsm">
            © {new Date().getFullYear()} Black Comet Labs. Small studio. Serious apps.
          </p>
        </div>
      </div>
    </footer>;
}